/**
 * File: useAuthUtils.ts
 * Path: apps/admin/src/modules/auth/hooks/useAuthUtils.ts
 * Description: Pure helpers and role-based access control predicates for authentication.
 */

import { UserProfile, UserRole } from "@idk/types";
import { useRole } from "./useRoleQueries";

export const useAuthUtils = () => {
  const roleInfo = useRole();

  return {
    // Re-export role status from useRole
    ...roleInfo,

    /**
     * Checks if the current user matches a specific required role.
     */
    hasRole: (requiredRole: UserRole): boolean => {
      return roleInfo.role === requiredRole;
    },

    /** Whether the role may edit website content. */
    canEdit: (_resource?: string): boolean => roleInfo.can("content"),

    /**
     * Returns a formatted display name from a user profile, with fallback logic.
     */
    formatDisplayName: (user?: UserProfile | null): string => {
      if (!user) return "Anonymous";
      return user.displayName || user.email || "Unknown User";
    },
  };
};
